<div class="library-dashboard-view" *ngIf="classFileList != ''">


  <div class="columns" *ngIf="isUserRole===1">
    <div class="column">
      <div class="box" style="cursor: pointer;">
        <article class="media">
          <div class="media-content">
            <div class="content" >
              <p class="title is-size-6">Total Users</p>
              <p class="subtitle is-size-6">{{totalUsersCount}}</p>
            </div>
          </div>
        </article>
      </div>
    </div>
    <div class="column">
      <div class="box"  style="cursor: pointer;">
        <article class="media">
          <div class="media-content">
            <div class="content" >
              <p class="title is-size-6">Lessons</p>
              <p class="subtitle is-size-6">{{totalLesson}}</p>
            </div>
          </div>
        </article>
      </div>
    </div>
  </div>
  <div class="dashboard-tag" *ngIf="isUserRole!=1" >
    <span class="tag is-danger">No.of Assessment Test, Survey and Poll</span>
    <span class="tag is-warning">Pending</span>
    <span class="tag is-info">Completed</span>

  </div>
  <div class="columns dashboard-card" *ngIf="isUserRole!=1">
    <div class="column">
      <div class="box" style="cursor: pointer;">
        <article class="media">
          <div class="media-content">
            <div class="content" >
              <p class="title is-size-6">Assessment Test</p>
              <div *ngIf="totalAssessmentTest; else elseAssTemplate">
                <div class="columns">
                  <div class="column is-three-fifths">
                    <div class="chart-wrapper">
                      <canvas baseChart
                        [data]="pieChartData"
                        [labels]="pieChartLabels"
                        [chartType]="pieChartType"
                        [options]="pieChartOptions"
                        [plugins]="pieChartPlugins"
                        [legend]="pieChartLegend"
                        [colors]="Assesscolors"
                        >
                      </canvas>
                    </div>
                  </div>
                  <div class="column" style="margin-left: -34px;">
                    <p style="margin-bottom: -6px;font-size: 20px;font-weight: bold;">{{totalAssessmentTest}}</p>
                    <span style="font-size: 12px;color: #ccc;">No. of Assessment Test</span>
                    <p style="margin-bottom: -6px;font-size: 20px;font-weight: bold;">{{completeAssessent}}</p>
                    <span style="font-size: 12px;color: #ccc;">Completed</span>
                    <p style="margin-bottom: -6px;font-size: 20px;font-weight: bold;">{{pendingAssessment}}</p>
                    <span style="font-size: 12px;color: #ccc;">Pending</span>
                  </div>
                </div>
              </div>
              <ng-template #elseAssTemplate>
                  <span>No Assessment Test Records</span>
              </ng-template>
            </div>
          </div>
        </article>
      </div>
    </div>
    <div class="column">
      <div class="box" style="cursor: pointer;">
        <article class="media">
          <div class="media-content">
            <div class="content" >
              <p class="title is-size-6">Survey</p>
              <div *ngIf="totalSurvey!=0; else elseSurTemplate">
                <div class="columns">
                  <div class="column is-three-fifths">
                    <div class="chart-wrapper">
                      <canvas baseChart
                        [data]="pieChartSurData"
                        [labels]="pieChartSurLabels"
                        [chartType]="pieChartSurType"
                        [options]="pieChartOptions"
                        [plugins]="pieChartSurPlugins"
                        [legend]="pieChartSurLegend"
                        [colors]="Surcolors"
                        >
                      </canvas>
                    </div>
                  </div>
                  <div class="column" style="margin-left: -34px;">
                    <p style="margin-bottom: -6px;font-size: 20px;font-weight: bold;">{{totalSurvey}}</p>
                    <span style="font-size: 12px;color: #ccc;">No. of Survey</span>
                    <p style="margin-bottom: -6px;font-size: 20px;font-weight: bold;">{{completeSurvey}}</p>
                    <span style="font-size: 12px;color: #ccc;">Completed</span>
                    <p style="margin-bottom: -6px;font-size: 20px;font-weight: bold;">{{pendingSurvey}}</p>
                    <span style="font-size: 12px;color: #ccc;">Pending</span>
                  </div>
                </div>
              </div>
              <ng-template #elseSurTemplate>
                <span>No Survey Records</span>
              </ng-template>
            </div>
          </div>
        </article>
      </div>
    </div>
    <div class="column">
      <div class="box" style="cursor: pointer;">
        <article class="media">
          <div class="media-content">
            <div class="content" >
              <p class="title is-size-6">Poll</p>
              <div *ngIf="totalPoll!=0; else elseTemplate">
                <div class="columns">
                  <div class="column is-three-fifths">
                    <div class="chart-wrapper">
                      <canvas baseChart
                        [data]="pieChartPollData"
                        [labels]="pieChartPollLabels"
                        [chartType]="pieChartPollType"
                        [options]="pieChartOptions"
                        [plugins]="pieChartPollPlugins"
                        [legend]="pieChartPollLegend"
                        [colors]="Pollcolors"
                        >
                      </canvas>
                    </div>
                  </div>
                  <div class="column" >
                    <p style="margin-bottom: -6px;font-size: 20px;font-weight: bold;">{{totalPoll}}</p>
                    <span style="font-size: 12px;color: #ccc;">No. of Poll</span>
                    <p style="margin-bottom: -6px;font-size: 20px;font-weight: bold;">{{completePoll}}</p>
                    <span style="font-size: 12px;color: #ccc;">Completed</span>
                    <p style="margin-bottom: -6px;font-size: 20px;font-weight: bold;">{{pendingPoll}}</p>
                    <span style="font-size: 12px;color: #ccc;">Pending</span>
                  </div>
                </div>
              </div>
              <ng-template #elseTemplate>
                <span>No Poll Records</span>
              </ng-template>
            </div>
          </div>
        </article>
      </div>
    </div>
  </div>

  <div class="flex-container" *ngIf="viewControl.showHideEditFileUpload && viewControl.hideExistingFileView">
    <div class="flex-item " *ngFor="let item of classFileList ; let $index=index;" >
      <div class="card" >
        <div class="card-content">
          <div class="media">
            <div class="media-content">
              <div class="columns ">
                <div class="column">
                  <p class="title is-7 is-capitalized" [title]="item.message">{{item.message!=''?item.message : 'No Title'}}</p>
                  <div *ngIf="isUserRole===1; else elseTemplate">
                  
                   <ng-container *ngIf="item.is_download || item.is_polls_found || item.is_survey_found || item.is_question_found">
                    <div class="fileBtnOptions has-text-right is-pulled-right is-4">
                      <div class="dropdown is-right" [ngClass]="{'is-active': show && dropdownIndex === $index}">
                        <div class="dropdown-trigger" (click)="clickit($event, $index)">
                          <a class="is-small pad-5-10 has-tooltip-left" data-tooltip="More Options">
                            <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                          </a>
                        </div>
                        <div class="dropdown-menu" id="dropdown-menu6" role="menu" (click)="$event.stopPropagation()">
                          <div class="dropdown-content">
                            <!-- <a class="dropdown-item" (click)="getQuizeDetails(item.message_id)">
                              <i class="fa fa-pencil" aria-hidden="true"></i> Edit
                            </a> -->
                            <a class="dropdown-item" *ngIf="item.is_question_found" (click)="loadAssessmentQuiz(item.message_id, 'question')">
                              <i class="fa fa-pencil" aria-hidden="true"></i> Assessment Result
                            </a>
                            <a class="dropdown-item" *ngIf="item.is_survey_found" (click)="loadAssessmentQuiz(item.message_id, 'survey')">
                              <i class="fa fa-pencil" aria-hidden="true"></i> Survey Result
                            </a>
                            <a class="dropdown-item" *ngIf="item.is_polls_found" (click)="loadAssessmentQuiz(item.message_id, 'polls')">
                              <i class="fa fa-pencil" aria-hidden="true"></i> Poll Result
                            </a>
                            <a class="dropdown-item" *ngIf="item.is_download" (click)="secureFileDownLoad(item)">
                              <i class="fa fa-download" aria-hidden="true"></i> Download
                            </a>
                            <!-- <hr class="dropdown-divider">
                            <a class="dropdown-item" (click)="deleteSecureFile(item.message_id)">
                              <i class="fa fa-trash" aria-hidden="true"></i> Delete
                            </a> -->
                          </div>
                        </div>
                      </div>
                    </div>
                    </ng-container> 
                  </div>
                  <ng-template #elseTemplate>
                    <div *ngIf="item.is_download || item.is_polls_found || item.is_survey_found || item.is_question_found">
                      <div class="fileBtnOptions has-text-right is-pulled-right is-4">
                        <div class="dropdown is-right" [ngClass]="{'is-active': show && dropdownIndex === $index}">
                          <div class="dropdown-trigger" (click)="clickit($event, $index)">
                            <a class="is-small pad-5-10" >
                              <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                            </a>
                          </div>
                          <div class="dropdown-menu" id="dropdown-menu6" role="menu" (click)="$event.stopPropagation()">
                            <div class="dropdown-content">
                              <a class="dropdown-item" *ngIf="item.is_question_found" (click)="loadAssessmentQuiz(item.message_id, 'question')">
                                <i class="fa fa-pencil" aria-hidden="true"></i> Assessment Test
                              </a>
                              <a class="dropdown-item" *ngIf="item.is_survey_found" (click)="loadAssessmentQuiz(item.message_id, 'survey')">
                                <i class="fa fa-pencil" aria-hidden="true"></i> Survey Quiz
                              </a>
                              <a class="dropdown-item" *ngIf="item.is_polls_found" (click)="loadAssessmentQuiz(item.message_id, 'polls')">
                                <i class="fa fa-pencil" aria-hidden="true"></i> Poll Quiz
                              </a>
                              <a class="dropdown-item" *ngIf="item.is_download" (click)="secureFileDownLoad(item)">
                                <i class="fa fa-download" aria-hidden="true"></i> Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                  <p class="shared">{{item.shared_by}}</p>
                  <p class="subtitle is-6">{{item.created_at | date:'MMM d, y'}}</p>
                  <p class="subtitle is-6" >{{item.read_user_ids?item.read_user_ids?.length : 0}} Views</p>
                  <p class="title has-text-right is-size-3 btn_buylesson" *ngIf="item.price > 0">$ {{item.price}}
                    <!-- <button *ngIf="item.price > 0" class="button is-link is-outlined is-small">Buy</button> -->
                  </p>
                  <!-- <span *ngIf="item.price!='0.00'; else elseTemplate">
                    <p class="title has-text-right is-size-3 btn_buylesson">$ {{item.price}}
                      <button *ngIf="item.price > 0" class="button is-link is-outlined is-small">Buy</button>
                    </p>
                  </span>
                  <ng-template #elseTemplate>
                    <p class="title has-text-right is-size-3 btn_buylesson">Free</p>
                  </ng-template> -->

                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <button *ngIf="item.price > 0" class="buylesson button is-dark is-small is-fullwidth">Buy</button> -->
      </div>
    </div>
  </div>

  <!--Play Media -->
  <div class="elibPlaying-Media" *ngIf="!viewControl.hideExistingFileView">
    <div class="columns">
      <div class="column is-8">
        <div class="card">
          <div class="card-content">
            <div class="media">

              <a class="selectFileRemove button is-small has-tooltip-left" (click)="hideReadFile(mesgIds)" *ngIf="activeModalSelectFile[mesgIds]" data-tooltip="Back to Lesson">
                <i class="fa fa-arrow-left" aria-hidden="true"></i>
              </a>
              <div class="content" *ngIf="!activeModalSelectFile[mesgIds]">
                  <a class="delete is-small" title="Hide Player" (click)="disabledVideoPlay()" *ngIf="!activeModalSelectFile[mesgIds]"></a>

                  <div class="cs-mediaplayer" *ngIf="mediaContent">
                    <div class="watermark_title">
                      <p class="bg-text">{{mediaContent.watermark}}</p>
                      </div>
                    <div *ngIf="mediaContent.file_type==='video' || mediaContent.file_type === 'audio'; else elseTemplate">
                      <div class="cs-media-player">
                        <!-- <span class="">{{mediaContent.watermark}}</span> -->
                        <vg-player *ngIf="mediaContent.file_type === 'video' || mediaContent.file_type === 'audio'" (onPlayerReady)="videoPlayerInit($event)">
                            <vg-overlay-play></vg-overlay-play>
                            <vg-buffering></vg-buffering>

                            <vg-scrub-bar>
                                <vg-scrub-bar-current-time></vg-scrub-bar-current-time>
                                <vg-scrub-bar-buffering-time></vg-scrub-bar-buffering-time>
                            </vg-scrub-bar>

                            <vg-controls [vgAutohide]="true" [vgAutohideTime]="2">
                                <vg-play-pause></vg-play-pause>
                                <vg-time-display vgProperty="total" vgFormat="mm:ss"></vg-time-display>
                                <vg-scrub-bar style="pointer-events: none;"></vg-scrub-bar>
                                <vg-mute></vg-mute>
                                <vg-volume></vg-volume>

                                <vg-fullscreen></vg-fullscreen>
                            </vg-controls>

                            <video #media [vgMedia]="media" id="singleVideo" preload="none">
                                <source [src]="inputSrc" type="video/mp4">
                            </video>
                            <!-- <p>{{videoWatermark}}</p> -->
                        </vg-player>
                      </div>
                    </div>
                    <ng-template #elseTemplate>
                      <div class="" *ngIf="mediaContent.file_type ==='image'; else elseTemplate" >
                        <img class="thumb_img" [src]="mediaContent.view_Url" [ngxWatermark]="options">
                      </div>
                      <ng-template #elseTemplate>
                        <div class="" >
                          <div class="mediaDocFile" *ngFor="let ic of uploadFileIcons">
                            <div class="imgFigure" *ngIf="ic.name===mediaContent.file_ext">
                              <div class="watermark_title">
                                <p class="bg-text">{{mediaContent.watermark}}</p>
                                </div>
                              <figure class="is-centered is-mobile is-desktop">
                                <img class="tile_imgcenter" [src]="ic.icons" >
                              </figure>
                              <a class="button is-link is-outlined thumb_play is-small" (click)="secureFileViewed(mediaContent.message_id, mediaContent)">
                                <i class="fa " [ngClass]="{'fa-eye': mediaContent.file_type!='audio', 'fa-play-circle-o': mediaContent.file_type==='audio'}" aria-hidden="true"></i> View Docment
                              </a>
                            </div>
                          </div>
                        </div>
                        <div *ngIf="activeModalSelectFile[mesgIds]">
                          <ngx-doc-viewer class="ngxDocViewer" queryParams="h1=N1" viewer="google" googleCheckContentLoaded="true"
                          googleCheckInterval="3000"
                          googleMaxChecks="5" [url]="selectedReadFile" style="width:100%;height:80vh;z-index: 999;" ></ngx-doc-viewer>
                          <a class="button pri-cus-btn mar-top15 is-loading"  *ngIf="showFileLoadSpinner"></a>
                          <button class="modal-close is-large" aria-label="close" (click)="hideReadFile(mesgIds)"></button>
                        </div>
                      </ng-template>
                    </ng-template>
                    <div class="columns">
                      <div class="column is-9">
                        <p class="is-size-6 title is-7" title="{{mediaContent.message}}" [innerHTML]="mediaContent.message"></p>
                        <p class="shared">{{mediaContent.shared_by}} - {{mediaContent.created_at | date:'MMM d, y'}}</p>
                      </div>
                      <div class="column" *ngIf="isUserRole!=1">
                        <div *ngIf="mediaContent.is_download || mediaContent.is_polls_found || mediaContent.is_survey_found || mediaContent.is_question_found">
                          <div class="fileBtnOptions has-text-right is-pulled-right is-4">
                            <div class="dropdown is-right" [ngClass]="{'is-active': show && dropdownIndex === $index}">
                              <div class="dropdown-trigger" (click)="clickit($event, $index)">
                                <a class="is-small pad-5-10" >
                                  <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                                </a>
                              </div>
                              <div class="dropdown-menu" id="dropdown-menu6" role="menu" (click)="$event.stopPropagation()">
                                <div class="dropdown-content">
                                  <a class="dropdown-item" *ngIf="is_question_found" (click)="loadAssessmentQuiz(mediaContent.messageId, 'question')">
                                    <i class="fa fa-pencil" aria-hidden="true"></i> Assessment Test
                                  </a>
                                  <a class="dropdown-item" *ngIf="is_survey_found" (click)="loadAssessmentQuiz(mediaContent.messageId, 'survey')">
                                    <i class="fa fa-pencil" aria-hidden="true"></i> Survey Quiz
                                  </a>
                                  <a class="dropdown-item" *ngIf="is_polls_found" (click)="loadAssessmentQuiz(mediaContent.messageId, 'polls')">
                                    <i class="fa fa-pencil" aria-hidden="true"></i> Poll Quiz
                                  </a>
                                  <a class="dropdown-item" *ngIf="mediaContent.is_download" (click)="secureFileDownLoad(mediaContent)">
                                    <i class="fa fa-download" aria-hidden="true"></i> Download
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <nav class="pagination is-small " role="navigation" aria-label="pagination">
                      <button class="button is-outlined pagination-previous" [disabled]="prevDisabled || this.classFileList.length===1" (click)="getPreVideo(currentIndex)">
                        Previous
                      </button>
                      <button class="button is-outlined pagination-next mar-5" [disabled]="nextDisabled || this.classFileList.length===1" (click)="getNextVideo(currentIndex)">
                        Next
                      </button>
                    </nav>
                    <h3 *ngIf="mediaContent.description" class="title is-3 descHeading">Description</h3>
                    <div [innerHTML]="mediaContent.description"></div>

                </div>
              </div>
              <div *ngIf="activeModalSelectFile[mesgIds]" style="width: 100%;">
                <ngx-doc-viewer class="ngxDocViewer" queryParams="h1=N1" popout-hide="none" viewer="google" googleCheckContentLoaded="true"
                googleCheckInterval="3000"
                googleMaxChecks="5" [url]="selectedReadFile" style="width:100%;height:80vh;z-index: 999;" ></ngx-doc-viewer>
                <a class="button pri-cus-btn mar-top15 is-loading"  *ngIf="showFileLoadSpinner"></a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-4">
        <div class="card events-card">
          <nav class="tabs is-info is-outlined is-boxed is-fullwidth is-small">
            <div class="container">
              <ul style="font-size: 15px;">
                <li class="tab is-active" (click)="openTab($event, 'lessons')"><a >Lessons</a></li>
                <li class="tab" *ngIf="isUserRole!=1" (click)="openTab($event,'notes')"><a >Notes</a></li>
              </ul>
            </div>
          </nav>

          <div class="container">
            <div id="lessons" class="content-tab" >
              <div class="card-table">
                <div class="content" >
                  <div class="list-wrapper scroll-bar list-overflow" appInfiniteScroll infinite-scroll [infiniteScrollDistance]="modalScrollDistance" [infiniteScrollThrottle]="modalScrollThrottle" [scrollWindow]="false" (scrolled)="fetchElibraryVideoList()">
                    <ul class="notification-list">
                      <li class="cursor-pointer pos-relative chat-list"  *ngFor="let vdo of classFileList; let $index=index" (click)="startPlayListVdo($index, vdo)"  [ngClass]="{'selectedActive': vdo===currentVideo ||vdo.message_id===currentVideoId}" >
                        <div class="columns is-gapless is-clearfix pos-relative display-flex">
                          <div class="column is-clearfix">
                            <p class="is-size-6 title list-active is-7" [title]="vdo.message">{{vdo.message?vdo.message: 'No Title'}}</p>
                            <p class="shared">{{vdo.shared_by}} - {{vdo.created_at | date:'MMM d, y'}}</p>
                          </div>
                          <div class="field is-small" *ngIf="currentVideoId">
                            <input class="is-checkradio is-small is-success is-circle " id="checkbox" type="checkbox" [checked]="vdo.message_id===currentVideoId" disabled>
                            <label for="checkbox"></label>
                          </div>
                        </div>
                      </li>
                      <pagination-loader [showFetchLoader]="showPaginateSpinner"></pagination-loader>
                    </ul>
                  </div>
                </div>
            </div>
            </div>
            <div id="notes" class="content-tab" style="display: none;">
              <div *ngIf="is_notes; else elseIsNotesTemplate">
                <form [formGroup]="userNotesForm">
                  <div class="scroll-bar pos-relative" appInfiniteScroll infinite-scroll [scrollWindow]="true" [infiniteScrollDistance]="modalScrollDistance" [infiniteScrollThrottle]="modalScrollThrottle">
                    <div class="cardcontent scroll-bar pos-relative" appInfiniteScroll infinite-scroll [scrollWindow]="true" [infiniteScrollDistance]="modalScrollDistance" [infiniteScrollThrottle]="modalScrollThrottle">
                      <div class="notes-form" style="padding: 10px;" *ngFor="let item of userNotes; let i=index">
                        <h3 class="notesFormHeading is-size-6 label mar-0-10">{{i+1}}. <span [innerHTML]="item.question"></span>
                        </h3>
                        <input type="hidden" id="{{item.question_id}}" name="question_id" formControlName="question_id" value="{{item.question_id}}">
                        <input type="hidden" id="{{item.user_notes_id}}" name="user_notes_id" formControlName="user_notes_id" value="{{item.user_notes_id}}">
                        <!-- <angular-editor class="scroll-bar" id="{{item.question_id}}" [config]="editorConfig" cols="10" rows="2" formControlName="user_notes" (change)="changeEventUserNotes(item, userNotesForm.value)"></angular-editor> -->
                        <textarea name="notes" class="textarea" id="user_notes_{{item.question_id}}" cols="30" rows="5" placeholder="Enter the short answer here..." formControlName="notes" (change)="changeEventUserNotes(item, userNotesForm.value)" [value]="item.notes?item.notes:''"></textarea>
                      </div>
                    </div>
                    <footer class="card-footer">
                      <div class="columns is-12" style="width: 100%;padding: 12px 0px;">
                        <div class="column is-6 has-text-left">
                          <a class="button mar-0-5 is-link is-small has-tooltip-right" data-tooltip="Download Notes" (click)="userNotesDownload(this.userNotes)">
                            <i class="fa fa-download" aria-hidden="true"></i>
                          </a>
                        </div>
                        <div class="column is-6 has-text-right">
                          <!-- <button type="button" class="button mar-0-5 is-small" [disabled]="upLoadedFileList.length > 0" (click)="clearUserNotes()">Clear</button> -->
                          <button type="button" class="actBtnMobileView button is-link is-small disabledBtn" [disabled]="(userNotesForm.valid && !userNotesForm.dirty) || userNotesForm.invalid " (click)="updatedUserNotes(userNotesForm.value, msgIds)" *ngIf="!showBtnSpinner && userNotes.length > 0">Update Notes</button>
                          <button type="button" class="actBtnMobileView button is-link is-small disabledBtn" [disabled]="(userNotesForm.valid && !userNotesForm.dirty) || userNotesForm.invalid " (click)="submitUserNotes(userNotesForm.value, msgIds)" *ngIf="!showBtnSpinner && userNotes.length===0">Save Notes</button>

                          <a class="button is-link is-loading is-small" style="min-width: 100px;"  *ngIf="showBtnSpinner"></a>
                        </div>
                      </div>

                    </footer>
                  </div>

                </form>
              </div>
              <ng-template #elseIsNotesTemplate>
                <form [formGroup]="userNotesForm">
                  <div class="scroll-bar pos-relative" appInfiniteScroll infinite-scroll [scrollWindow]="true" [infiniteScrollDistance]="modalScrollDistance" [infiniteScrollThrottle]="modalScrollThrottle">
                    <div class="notes-form" style="padding: 10px;" >
                      <input type="hidden" class="input" name="user_notes_id" formControlName="user_notes_id" />
                      <angular-editor class="scroll-bar" id="notes" [config]="editorIsNotesConfig" cols="10" rows="2" formControlName="notes" ></angular-editor>
                    </div>
                    <footer class="card-footer">
                      <div class="columns is-12" style="width: 100%;padding: 12px 0px;">
                        <div class="column is-6 has-text-left">
                          <a class="button mar-0-5 is-link is-small has-tooltip-right" data-tooltip="Download Notes" (click)="userNotesDownload(this.userNotes)">
                            <i class="fa fa-download" aria-hidden="true"></i>
                          </a>
                        </div>
                        <div class="column is-6 has-text-right">
                          <!-- <button type="button" class="button mar-0-5 is-small" [disabled]="upLoadedFileList.length > 0" (click)="clearUserNotes()">Clear</button> -->
                          <button type="button" class="actBtnMobileView button is-link is-small disabledBtn" [disabled]="(userNotesForm.valid && !userNotesForm.dirty) || userNotesForm.invalid " (click)="submitUserNotes(userNotesForm.value, msgIds)" *ngIf="!showBtnSpinner && userNotes.length===0">Save Notes</button>
                          <button type="button" class="actBtnMobileView button is-link is-small disabledBtn" [disabled]="(userNotesForm.valid && !userNotesForm.dirty) || userNotesForm.invalid " (click)="updatedUserNotes(userNotesForm.value, msgIds)" *ngIf="!showBtnSpinner && userNotes.length > 0">Update Notes</button>
                          <a class="button is-link is-loading is-small" style="min-width: 100px;"  *ngIf="showBtnSpinner"></a>
                        </div>
                      </div>

                    </footer>
                  </div>

                </form>
              </ng-template>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!---Questionnarie-->
  <div class="library_tile_view" *ngIf="!viewControl.showHideEditFileUpload">
    <div class="flex-container editedFileUpload" >
      <div class="flex-item" style="width: 100%;">
        <div class="card scroll-bar pos-relative" appInfiniteScroll infinite-scroll [scrollWindow]="true" [infiniteScrollDistance]="modalScrollDistance" [infiniteScrollThrottle]="modalScrollThrottle">
          <div class="card-header">
            <p class="card-header-title">Edit Upload</p>
          </div>
          <form [formGroup]="editQuizForm" novalidate >
            <div class="card-content scroll-bar pos-relative" infinite-scroll>
              <div class="content">
                <div class="columns is-clearfix" >
                  <div class="column is-5">

                    <div class="field post-attach-file" >
                      <div class="control file is-boxed is-fullwidth is-info-light" *ngIf="!preUploadedFile && !uploadAttachFile">
                        <label class="file-label">
                          <input type="file" name="msg-file" style="display:none" #topicFileInput (change)="onFileChange($event)" accept=".png, .jpeg, .jpg, .mp3, .mp4, .wav, .pdf, .ppt, .pptx, .pptm, .xml, .xls, .xlsx, .doc, .docx, .txt" >
                          <span class="file-cta">
                            <span class="file-icon">
                              <i class="fa fa-upload"></i>
                            </span>
                            <span class="file-label is-small is-centered">
                              Attach file here…
                            </span>
                          </span>
                        </label>
                      </div>
                    </div>
                    <div *ngIf="upLoadedFileList.length > 0">
                      <div class="pos-relative" *ngFor="let eachFile of upLoadedFileList">
                        <div class="file-detail">
                          <div class="content-align">
                            <p><img  src="../../../../assets/images/file_types/{{eachFile.mimeType}}.png" width="35px" height="35px"> {{eachFile.name}}</p>
                            <span class="file-size is-small">{{eachFile.size | fileSize}}</span>
                            <progress class="progress is-link is-small" value="{{eachFile.progressVal}}" max="100" *ngIf="eachFile.progressVal"></progress>
                          </div>
                        </div>
                        <!-- <i class="fa fa-times" aria-hidden="true" (click)="removeFileFromList(eachFile)"></i> -->
                      </div>
                    </div>
                    <div class="is-small" *ngIf="preUploadedFile && uploadAttachFile; else elseTemplate">
                      <div *ngFor="let f of uploadFileIcons">
                        <span *ngIf="f.name===preUploadedFile.file_ext">
                          <img [src]="f.icons" alt="" width="35px" height="35px">{{preUploadedFile.file_id}}

                          <button class="delete" aria-label="Delete" title="Remove upload file" (click)="removeUploadFile(upLoadedFileList, editedData['duration'])"></button>
                        </span>
                      </div>
                    </div>
                    <ng-template #elseTemplate>
                        <div *ngIf="uploadAttachFile && upLoadedFileList.length===0">
                          <span>
                            <p><img  src="../../../../assets/images/file_types/{{editedData['file_ext']}}.png" width="35px" height="35px"> {{editedData['file_id']}}
                            <button class="delete" aria-label="Delete" title="Remove existing file" (click)="removeExitingFile(editedData['file_id'], editedData['duration'])"></button></p>
                          </span>
                        </div>
                      <!-- <div *ngFor="let f of uploadFileIcons">
                        <div *ngIf="uploadAttachFile && upLoadedFileList.length===0">
                          <span *ngIf="f.name===editedData['file_ext']">
                            <img [src]="f.icons" alt="" width="35px" height="35px"> {{editedData['file_id']}}
                            <button class="delete" aria-label="Delete" (click)="removeExitingFile(editedData['file_id'], editedData['duration'])"></button>
                          </span>
                        </div>
                      </div> -->
                    </ng-template>
                    <div class="field">
                      <label class="label">Duration</label>
                      <div class="control">
                        <input class="input" type="text" id="fileDuration" name="duration" placeholder="Video/Audio File Duration" #durationInput formControlName="duration" [readonly]="true">
                      </div>
                    </div>
                    <div class="field">
                      <label class="label">Title
                        <span class="required">*</span>
                      </label>
                      <div class="control">
                        <input class="input" type="text" name="title" [(ngModel)]="editedData['message']" placeholder="Title" formControlName="message">
                      </div>
                    </div>
                    <div class="field responsiveRadioBtn">
                      <input id="switchDownload" type="checkbox" name="is_download" class="switch is-small is-success" formControlName="is_download" [(ngModel)]="isDownload">
                      <label for="switchDownload">Allow download?</label>
                    </div>
                    <div class="field responsiveRadioBtn">
                      <input id="switchPublish" type="checkbox" name="is_publish" class="switch is-small is-success" formControlName="is_publish" [(ngModel)]="isPublish">
                      <label for="switchPublish">Ready to publish?</label>
                    </div>
                    <!-- <div class="columns" style="margin-top: 5px;margin-bottom: 0px;">
                      <div class="column is-6">
                        <div class="field">
                          <input id="switchDownload" type="checkbox" name="is_download" class="switch is-small is-success" formControlName="is_download" [(ngModel)]="isDownload">
                          <label for="switchDownload">Allow download?</label>
                        </div>
                      </div>
                      <div class="column">
                        <div class="field">
                          <input id="switchPublish" type="checkbox" name="is_publish" class="switch is-small is-success" formControlName="is_publish" [(ngModel)]="isPublish">
                          <label for="switchPublish">Ready to publish?</label>
                        </div>
                      </div>
                    </div> -->
                    <div class="field">
                      <label class="label">Description</label>
                      <div class="control">
                        <angular-editor class="scroll-bar" [config]="editorConfig" cols="10" rows="2" formControlName="description"></angular-editor>
                      </div>
                    </div>
                    <div class="field">
                      <label class="label">Price $</label>
                      <div class="control">
                        <input type="text" class="input" name="price" [(ngModel)]="editedData['price']" placeholder="Price $ 0.00" formControlName="price" (keypress)="numberOnlyValidator($event)" (keydown)="IsDecimalValue($event)">
                        <p class="is-small has-text-danger" *ngIf="priceValidate">{{priceErrMsg}}</p>
                      </div>
                    </div>
                    <div class="field">
                      <label class="label">Discount %</label>
                      <div class="control">
                        <input type="text" class="input" name="discount" [(ngModel)]="editedData['discount']" placeholder="Discount" formControlName="discount" (keypress)="isNumberKey($event)" maxlength="3" (keyup)="discountPercentage($event)">
                        <p class="is-small has-text-danger" *ngIf="discountValidate">{{priceErrMsg}}</p>
                      </div>
                    </div>
                    <div class="field">
                      <label class="label">Watermark Title</label>
                      <div class="control">
                        <input type="text" class="input" name="watermark_title" [(ngModel)]="editedData['water_mark_title']" placeholder="Watermark Title" formControlName="water_mark_title">
                      </div>
                    </div>
                    <!-- <div class="field">
                      <div class="field-label" style="text-align: left;">
                        <label class="label">Allow download?
                          <span class="required">*</span>
                        </label>
                      </div>
                      <div class="field-body">
                        <div class="field is-narrow">
                          <div class="control">
                            <label class="radio" *ngFor="let fd of file_download; let i=index">
                              <input type="radio" name="is_download" [value]="fd.value" [(ngModel)]="editedData['is_download']" [checked]="fd.value===isChecked" formControlName="is_download">
                              {{fd.name}}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="field">
                      <div class="field-label" style="text-align: left;">
                        <label for="" class="label">Ready to publish?
                          <span class="required">*</span>
                        </label>
                      </div>
                      <div class="field-body">
                        <div class="field is-narrow">
                          <div class="control">
                            <label class="radio" *ngFor="let p of publish; let i=index">
                              <input type="radio" name="is_publish" [value]="p.value" [checked]="p.value===pub_article" [(ngModel)]="editedData['is_publish']" formControlName="is_publish" >
                              {{p.title}}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div> -->
                  </div>
                  <div class="column is-7 questionnarieMobile">
                    <div class="field">
                      <nav class="tabs is-info is-outlined is-boxed is-fullwidth is-small" style="margin-top: -14px;">
                        <div class="container">
                          <ul style="font-size: 15px;margin-left: 0em;">
                            <li class="tab is-active" (click)="openTab($event, 'assessment')"><a >Assessment Test</a></li>
                            <li class="tab" (click)="openTab($event,'survey')"><a >Survey</a></li>
                            <li class="tab" (click)="openTab($event,'poll')"><a >Poll</a></li>
                            <li class="tab" (click)="openTab($event,'notes')"><a >Notes</a></li>
                          </ul>
                        </div>
                      </nav>
                      <div class="container">
                        <div id="assessment" class="content-tab">
                          <div class="field">
                            <a class="button is-link is-outlined is-small has-tooltip-top mar-0-5"  *ngIf="!domElementControl.showCreateNewQuestions"    data-tooltip="Add your first question" (click)="onCreateAssQuestion()">
                              <i class=" fa-solid fa-circle-plus mar-0-5" aria-hidden="true"></i> Add your question
                            </a>
                            <section class="section" *ngIf="domElementControl.showCreateNewQuestions && is_question_found">
                              <div class="container" formArrayName="assessment">
                                <div class="questionnarie" *ngFor="let assessmentCtrl of assQuestion().controls; let questIndex=index">
                                  <div class="" [formGroupName]="questIndex">
                                    <input type="text" name="question" id="question_{{questIndex}}" class="input" placeholder="Enter the question" formControlName="question">
                                    <input type="hidden" name="question_id" id="question_id_{{questIndex}}" class="input" placeholder="Enter the question" formControlName="question_id">
                                    <a class="icon removeAssQuestion has-text-grey-lighter has-tooltip-left" data-tooltip="Remove Question" *ngIf="assQuestion().length > 0" (click)="removeAssQuestion(questIndex)">
                                      <i class="fa fa-times-circle mar-0-5"></i>
                                    </a>
                                    <div *ngIf="(assessmentCtrl.get('question').touched || assessmentCtrl.get('question').dirty) && assessmentCtrl.get('question').invalid">
                                      <div class="has-text-danger is-size-6" *ngIf="assessmentCtrl.get('question').hasError('whitespace')">Question is required</div>
                                    </div>

                                    <div class="question-choice" style="padding: 1rem 0rem 1rem 0rem;">
                                      <div class="field">
                                        <div class="label">
                                          <label class="label">Question Type
                                            <span class="required"> *</span>
                                          </label>
                                        </div>
                                        <div class="field-body">
                                          <div class="field is-narrow">
                                            <div class="control">
                                              <div class="radio" *ngFor="let item of questions; let i = index">
                                                <input [value]="item.value" [id]="i" formControlName="answer_type" type="radio" (click)="onSelectedType(item, questIndex)">
                                                {{ item.viewValue }}
                                             </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <div class="question-option" [ngClass]="{'questionOption': removeAnsClass[questIndex]}" formArrayName="answer" >
                                      <div class="control" *ngFor="let answerCtrl of assQuestAnswers(questIndex).controls; let optionIndex=index">
                                        <div class="" [formGroupName]="optionIndex">
                                          <input type="text" name="answer" class="input" id="answer_{{optionIndex}}" placeholder="Enter the answer" formControlName="answer">
                                          <input type="hidden" name="answer_id" class="input" id="answer_id_{{optionIndex}}" placeholder="Enter the answer" formControlName="answer_id">
                                          <input type="radio" class="is-checkradio" [ngClass]="{'is-danger': selectedOptions[questIndex]}" name="is_correct_answer{{questIndex}}" id="correctAnswer_{{questIndex}}-{{optionIndex}}" [checked]="answerCtrl.value.is_correct_answer" value="{{isChecked}}" (click)="onCheckedAnswer($event, assessmentCtrl, questIndex, optionIndex)" >
                                          <label for="correctAnswer_{{questIndex}}-{{optionIndex}}" title="Check correct answer" ></label>
                                          <a class="icon has-text-grey-lighter has-tooltip-left removeOptions" data-tooltip="Remove Answer" *ngIf="assQuestAnswers(questIndex).controls.length > 1" (click)="removeAssOptions(questIndex, optionIndex, answerCtrl)">
                                            <i class="fa fa-times-circle" aria-hidden="true"></i>
                                          </a>
                                          <div *ngIf="(answerCtrl.get('answer').touched || answerCtrl.get('answer').dirty) && answerCtrl.get('answer').invalid">
                                            <div class="has-text-danger is-size-6" *ngIf="answerCtrl.get('answer').hasError('whitespace')">Answer is required</div>
                                          </div>
                                        </div>
                                      </div>
                                      <a *ngIf="isShown[questIndex]" class="button is-link is-outlined is-small has-tooltip-top" data-tooltip="Add more choice" (click)="onCreateAssOption(questIndex)">
                                        <i class=" fa-solid fa-circle-plus mar-0-5" aria-hidden="true"></i> Add more choice
                                      </a>
                                    </div>
                                    <div class="columns questionnarieAns" >
                                      <div class="column is-6">
                                        <div class="field">
                                          <div class="control">
                                            <input type="text" class="input" [ngClass]="{'is-danger': markOptions[questIndex]}" name="mark" id="mark_{{questIndex}}" placeholder="Enter the mark" formControlName="mark" (keypress)="numericOnlyHandler($event)">
                                            <div *ngIf="(assessmentCtrl.get('mark').touched || assessmentCtrl.get('mark').dirty) && assessmentCtrl.get('mark').invalid">
                                              <div class="has-text-danger is-size-6" *ngIf="assessmentCtrl.get('mark').hasError('whitespace')">Mark is required</div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <p class="has-text-danger is-small is-size-6" *ngIf="selectedOptions[questIndex]">Please select any one answer</p>
                                </div>
                                <a class="button is-link is-outlined is-small has-tooltip-top" data-tooltip="Add new question" (click)="onCreateAssQuestion()">
                                  <i class=" fa-solid fa-circle-plus mar-0-5" aria-hidden="true"></i> Add new question
                                </a>
                              </div>
                            </section>
                          </div>
                        </div>
                        <div id="survey" class="content-tab" style="display: none;">
                          <div class="field" >
                            <a class="button is-link is-outlined is-small has-tooltip-top"
                            *ngIf="!domElementControl.showCreateNewSurQuestion" (click)="onCreateSurveyQuestion()">
                              <i class=" fa-solid fa-circle-plus mar-0-5" aria-hidden="true"></i> Add your question
                            </a>
                            <section class="section" *ngIf="domElementControl.showCreateNewSurQuestion && is_survey_found">
                              <div class="container" formArrayName="survey">
                                <div class="questionnarie" *ngFor="let surveyCtrl of surveyQuestions().controls; let questIndex=index">
                                  <div class="" [formGroupName]="questIndex">
                                    <input type="text" name="question" id="question_{{questIndex}}" class="input" placeholder="Enter the question" formControlName="question">
                                    <a class="icon removeAssQuestion has-text-grey-lighter has-tooltip-left" data-tooltip="Remove Question" *ngIf="surveyQuestions().controls.length > 0" (click)="onRemoveSurveyQuestion(questIndex)">
                                      <i class="fa fa-times-circle mar-0-5"></i>
                                    </a>
                                    <div *ngIf="(surveyCtrl.get('question').touched || surveyCtrl.get('question').dirty) && surveyCtrl.get('question').invalid">
                                      <div class="has-text-danger is-size-6" *ngIf="surveyCtrl.get('question').hasError('whitespace')">Question is required</div>
                                    </div>
                                    <div class="question-option" formArrayName="answer">
                                      <div class="control" *ngFor="let answerCtrl of surveyOptions(questIndex).controls; let optionIndex=index">
                                        <div class="" [formGroupName]="optionIndex">
                                          <input type="text" name="answer" class="input" id="answer_{{optionIndex}}" placeholder="Enter the answer" formControlName="answer">
                                          <label for="correctAnswer_{{questIndex}}-{{optionIndex}}" title="Check correct answer"></label>
                                          <a class="icon has-text-grey-lighter has-tooltip-left removeOptions" data-tooltip="Remove Answer" *ngIf="surveyOptions(questIndex).controls.length > 1" (click)="removeSurveyOptions(questIndex, optionIndex)">
                                            <i class="fa fa-times-circle" aria-hidden="true"></i>
                                          </a>
                                          <div *ngIf="(answerCtrl.get('answer').touched || answerCtrl.get('answer').dirty) && answerCtrl.get('answer').invalid">
                                            <div class="has-text-danger is-size-6" *ngIf="answerCtrl.get('answer').hasError('whitespace')">Answer is required</div>
                                          </div>
                                        </div>
                                      </div>
                                      <a class="button is-link is-outlined is-small has-tooltip-top" data-tooltip="Add more choice" (click)="oncreateSurveyOptions(questIndex)">
                                        <i class=" fa-solid fa-circle-plus mar-0-5" aria-hidden="true"></i> Add more choice
                                      </a>
                                    </div>
                                  </div>
                                </div>
                                <a class="button is-link is-outlined is-small has-tooltip-top" data-tooltip="Add new question" (click)="onCreateSurveyQuestion()">
                                  <i class=" fa-solid fa-circle-plus mar-0-5" aria-hidden="true"></i> Add new question
                                </a>
                              </div>
                            </section>
                          </div>
                        </div>
                        <div id="poll" class="content-tab" style="display: none;">
                          <div class="field">
                            <a class="button is-link is-outlined is-small has-tooltip-top mar-0-5"  *ngIf="!domElementControl.showCreateNewPolQuestion" data-tooltip="Add your first question" (click)="onCreatePollQuestion()">
                              <i class=" fa-solid fa-circle-plus mar-0-5" aria-hidden="true"></i> Add your question
                            </a>
                            <section class="section" *ngIf="domElementControl.showCreateNewPolQuestion && is_polls_found">
                              <div class="container" formArrayName="polls">
                                <div class="questionnarie" *ngFor="let pollCtrl of pollQuestions().controls; let questIndex=index">
                                  <div class="" [formGroupName]="questIndex">
                                    <input type="text" name="question" id="question_{{questIndex}}" class="input" placeholder="Enter the question" formControlName="question">
                                    <input type="hidden" name="question_id" id="question_id_{{questIndex}}" class="input" placeholder="Enter the question" formControlName="question_id">
                                    <a class="icon removeAssQuestion has-text-grey-lighter has-tooltip-left" data-tooltip="Remove Question" *ngIf="pollQuestions().controls.length > 0" (click)="removePollQuestion(questIndex)">
                                      <i class="fa fa-times-circle mar-0-5"></i>
                                    </a>
                                    <div *ngIf="(pollCtrl.get('question').touched || pollCtrl.get('question').dirty) && pollCtrl.get('question').invalid">
                                      <div class="has-text-danger is-size-6" *ngIf="pollCtrl.get('question').hasError('whitespace')">Question is required</div>
                                    </div>
                                    <div class="question-option" formArrayName="answer">
                                      <div class="control" *ngFor="let answerCtrl of pollOptions(questIndex).controls; let optionIndex=index">
                                        <div class="" [formGroupName]="optionIndex">
                                          <input type="text" name="answer" class="input" id="answer_{{optionIndex}}" placeholder="Enter the answer" formControlName="answer">
                                          <input type="hidden" name="answer_id" class="input" id="answer_id_{{optionIndex}}" placeholder="Enter the answer" formControlName="answer_id">
                                          <a class="icon has-text-grey-lighter has-tooltip-left removeOptions" data-tooltip="Remove Answer" *ngIf="pollOptions(questIndex).controls.length > 1" (click)="onRemovePollOptions(questIndex, optionIndex, answerCtrl)">
                                            <i class="fa fa-times-circle" aria-hidden="true"></i>
                                          </a>
                                          <div *ngIf="(answerCtrl.get('answer').touched || answerCtrl.get('answer').dirty) && answerCtrl.get('answer').invalid">
                                            <div class="has-text-danger is-size-6" *ngIf="answerCtrl.get('answer').hasError('whitespace')">Answer is required</div>
                                          </div>
                                        </div>
                                      </div>
                                      <a class="button is-link is-outlined is-small has-tooltip-top" data-tooltip="Add more choice" (click)="onCreatePollOptions(questIndex)">
                                        <i class=" fa-solid fa-circle-plus mar-0-5" aria-hidden="true"></i> Add more choice
                                      </a>
                                    </div>
                                  </div>
                                </div>
                                <a class="button is-link is-outlined is-small has-tooltip-top" data-tooltip="Add new question" (click)="onCreatePollQuestion()">
                                  <i class=" fa-solid fa-circle-plus mar-0-5" aria-hidden="true"></i> Add new question
                                </a>
                              </div>
                            </section>
                          </div>
                        </div>
                        <div id="notes" class="content-tab" style="display:none">
                          <div class="field">
                            <a class="button is-link is-outlined is-small has-tooltip-top" *ngIf="!domElementControl.showCreateNewNotesQuestion" (click)="onCreateNotesQuestion()">
                              <i class=" fa-solid fa-circle-plus mar-0-5" aria-hidden="true"></i> Add your notes question
                            </a>
                          </div>
                          <section class="section" *ngIf="domElementControl.showCreateNewNotesQuestion && is_notes_found">
                            <div class="container" formArrayName="notes">
                              <div class="questionnarie" *ngFor="let notesCtrl of notesQuestions().controls; let questIndex=index">
                                <div class="" [formGroupName]="questIndex">
                                  <!-- <input type="text" name="question" id="question_{{questIndex}}" class="input" placeholder="Enter the notes question" formControlName="question"> -->
                                  <angular-editor class="scroll-bar" id="question_{{questIndex}}" formControlName="question" [config]="editorNotesConfig" cols="10" rows="5"></angular-editor>
                                    <a class="icon removeAssQuestion has-text-grey-lighter has-tooltip-left" data-tooltip="Remove Question" *ngIf="notesQuestions().length > 1" (click)="removeNotesQuestion(questIndex)">
                                      <i class="fa fa-times-circle mar-0-5"></i>
                                    </a>
                                    <div *ngIf="(notesCtrl.get('question').touched || notesCtrl.get('question').dirty) && notesCtrl.get('question').invalid">
                                      <div class="has-text-danger is-size-6" *ngIf="notesCtrl.get('question').hasError('whitespace')">Question is required</div>
                                    </div>
                                </div>
                              </div>
                              <a class="button is-link is-outlined is-small has-tooltip-top" data-tooltip="Add new question" (click)="onCreateNotesQuestion()">
                                <i class=" fa-solid fa-circle-plus mar-0-5" aria-hidden="true"></i> Add new notes question
                              </a>
                            </div>
                          </section>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <footer class="card-footer">
              <div class="column is-12 has-text-right">
                <button type="button" class="button mar-0-5 is-small" [disabled]="upLoadedFileList.length > 0" (click)="hideEditModal(upLoadedFileList, editedData['duration'])">Cancel</button>
                <button type="button" class="actBtnDeskView button is-link is-small disabledBtn" [disabled]="(editQuizForm.valid && !editQuizForm.dirty) || editQuizForm.invalid " (click)="updateFileData(editQuizForm.value, editedData['message_id'])" *ngIf="!showBtnSpinner">Update</button>
                <button type="button" class="actBtnMobileView button is-link is-small disabledBtn" [disabled]="(editQuizForm.valid && !editQuizForm.dirty) || editQuizForm.invalid " (click)="updateFileDataMobile(editQuizForm.value, editedData['message_id'])" *ngIf="!showBtnSpinner">Update</button>
                <a class="button is-link is-loading is-small" style="min-width: 100px;"  *ngIf="showBtnSpinner"></a>
              </div>
            </footer>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="empty-state">
  <div class="common-empty topic-notify" *ngIf="this.classFileList.length==0">
    <article class="media">
      <div class="media-content has-text-centered">
        <!-- <i class="fa fa-book" aria-hidden="true"></i> -->
        <!-- <img [src]="'../../../../assets/images/notification_empty.svg'"> -->
        <p>No records found.</p>
      </div>
    </article>
  </div>
</div>


<div class="showAssignment">

  <!--Assessment Test View-->
  <div class="modal"  [ngClass]="{'is-active': showHiddenAssessmentModal[mesgIds]}">
    <div class="modal-background"></div>
    <div class="modal-card" style="padding:20px">
      <div class="card " *ngIf="isUserRole!=1 && viewControl.showAssessmentMarks" >
        <form [formGroup]="assessmentForm" class="assQuestTest">
          <div class="card-header">
            <p class="card-header-title">Assessment Test</p>
            <span class="card-header-title is-size-6 has-text-right" style="font-weight: normal; position: absolute;right: 0;">No.of Questions: {{pager.count}}</span>
            <button class="delete" aria-label="close" *ngIf="isUserRole===1" (click)="hideModalAssessment(mesgIds)"></button>
          </div>
          <div class="card-content scroll-bar pos-relative"  appInfiniteScroll infinite-scroll [infiniteScrollDistance]="modalScrollDistance" [infiniteScrollThrottle]="modalScrollThrottle" [scrollWindow]="false">
            <div class="content">
              <div class="notification is-danger is-light" *ngIf="assetFormValid">
                <button class="delete"></button>
                Must check some option!
                </div>
              <div class="question" >
                <div *ngFor="let data of getAssessmentData; let i=index" style="padding-bottom: 10px;">
                  <div *ngIf="data.question_type==='question'">
                    <h3 class="is-medium label is-size-6">Q{{i+1}}.
                      <span class="is-medium is-size-6" [innerHTML]="data.question"></span>
                    </h3>
                    <div *ngIf="data.answer_type==='choice'; else elseTemplate">
                      <div class="options surveyquiz" >
                        <div class="" *ngFor="let option of data.answer; let i=index">
                          <div class="option has-text-grey-light">
                            <div class="field">
                              <input class="is-checkradio" id="{{data.question_id}}-{{ option.answer_id }}" type="radio" name="{{data.question_id}}-answers" value="{{option.answer_id}}" (change)="onSelectedAssRadio(data, option, assessmentForm.value)" >
                              <label class="is-size-6" style="font-size: 15px !important" for="{{data.question_id}}-{{ option.answer_id }}">{{option.answer}}</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <ng-template #elseTemplate>
                      <textarea name="user_answer" class="textarea" id="" cols="30" rows="5" placeholder="Enter the short answer here..." formControlName="user_answer" (change)="onSelectedAssRadio(data, option, assessmentForm.value)"></textarea>
                    </ng-template>
                  </div>
                </div>
              </div>
              <!-- <div class="field">
                <div class="control">
                  <input type="hidden" class="input" name="ovarallmark" id="ovarallmark" formControlName="ovarallmark" [value]="totalMarks" >
                </div>
              </div> -->
            </div>
          </div>
          <footer class="card-footer">
            <div class="has-text-right footer-elibrary">
              <button type="button" class="button mar-0-5 is-small" (click)="hideAssessmentModal(mesgIds)" >Cancel</button>
              <button type="button" class="button is-link is-small" *ngIf="!showBtnSpinner" [disabled]="!assessmentSubmit" (click)="submitAssessmentQuiz(assessmentForm.value, mesgIds, 'question')">Submit Test</button>
              <a class="button is-link is-loading is-small" style="min-width: 100px;"  *ngIf="showBtnSpinner"></a>
            </div>
          </footer>
        </form>
      </div>

      <div class="card" *ngIf="!viewControl.showAssessmentMarks">
        <div class="card-header">
          <p class="card-header-title">Result</p>
          <button
            class="button is-primary is-light" style="margin-right: 14px;"
            (click)="onClickTakeRetest(mesgIds)" *ngIf="isTakeRetest"
          >Take Retest</button>
          <button class="delete" aria-label="close" (click)="hideModalAssessment(mesgIds)"></button>
        </div>
        <div class="card-content">
          <div class="content">
            <table class="table">
              <thead>
                <tr>
                  <th>Test Complete Date</th>
                  <th>Percentage %</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let st of getUserTestResult">
                  <td>{{st.createdAt | date: 'MM/dd/yyyy'}}</td>
                  <td>{{st.percentage}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="card" *ngIf="isUserRole === 1">
        <div class="card-header">
          <p class="card-header-title">
            Assessment Result
            <a
              *ngIf="!viewControl.individualStudentResult && viewControl.showIndStudentResult"
              (click)="hideStudentResults()"
              class="mar-0-5 has-tooltip-right"
              data-tooltip="Back to user"
            >
              <i
                class="fa fa-arrow-left"
                aria-hidden="true"
                style="color: #fff"
              ></i>
            </a>
            <a
              *ngIf="!viewControl.showIndStudentResult"
              (click)="removeIndStudentResult()"
              class="mar-0-5 has-tooltip-right"
              data-tooltip="Back to user"
            >
              <i
                class="fa fa-arrow-left"
                aria-hidden="true"
                style="color: #fff"
              ></i>
            </a>
          </p>
          <button
            class="delete"
            aria-label="close"
            (click)="hideModalAssessment(mesgIds)"
          ></button>
        </div>
        <div class="card-content" *ngIf="viewControl.individualStudentResult && viewControl.showIndStudentResult">
          <!-- <div class="columns"> -->
          <div *ngIf="studentResult.length > 0; else elseTemplate">
            <!-- <div class="column is-12 is-fullwidth"> -->
            <table class="table is-fullwidth">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>User Name</th>
                  <th>Email Id</th>
                  <th>Percentage %</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let m of studentResult">
                  <td>{{m.createdAt | date: 'MM/dd/yyyy'}}</td>
                  <td
                    style="text-transform: capitalize"
                    [innerHTML]="m.student_name"
                  ></td>
                  <td>{{m.email_id}}</td>
                  <td>{{ m.percentage }}</td>
                  <td>
                    <button
                      type="button"
                      class="button mar-0-5 is-small is-link"
                      (click)="indStudentResult(m)"
                    >
                      View
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
            <!-- </div> -->
          </div>
          <!-- </div> -->
          <ng-template #elseTemplate>
            <span class="">There is no test submitted by the user</span>
          </ng-template>
        </div>
        <div
          class="card-content scroll-bar pos-relative"
          *ngIf="!viewControl.individualStudentResult && viewControl.showIndStudentResult"
        >
          <div class="content">
            <div class="question">
              <h3 style="text-transform: capitalize">{{individualStudentRecord[0]['student_name']}}</h3>
              <table class="table is-fullwidth">
                <thead>
                  <tr>
                    <th>Date & Time</th>
                    <th>Percentage %</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let m of individualStudentRecord">
                    <td>{{m.createdAt | date: 'MM/dd/yyyy hh:mm'}}</td>
                    <td>{{ m.percentage }}</td>

                    <td>
                      <button
                        type="button"
                        class="button mar-0-5 is-small is-link" [ngClass]="{'btnQAdisabled': m.answer_submissionId==null}"
                        (click)="onClickStudentIndResult(m)"
                      >
                        View QA
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div
          class="card-content scroll-bar pos-relative"
          *ngIf="!viewControl.showIndStudentResult"
        >
          <div class="content">
            <div class="question">
              <form>
                <div
                  *ngFor="let data of viewStudentQA; let i = index"
                  style="padding-bottom: 10px"
                >

                  <div *ngIf="data.question_type == 'question'">
                    <h3 class="is-medium label is-size-6">
                      Q{{ i + 1 }}.
                      <span
                        class="is-medium is-size-6"
                        [innerHTML]="data.question"
                      ></span>
                    </h3>
                    <div
                      *ngIf="data.answer_type === 'choice'; else elseTemplate"
                    >
                      <!-- <div class="options surveyquiz" >
                        <div class="" *ngFor="let option of data.answer; let i=index">
                          <div class="option has-text-grey-light">
                            <div class="field">
                              <input class="is-checkradio" id="{{data.question_id}}-{{ option.answer_id }}" type="radio" name="{{data.question_id}}-answers" value="{{option.answer_id}}" (change)="onSelectedAssRadio(data, option, assessmentForm.value)" >
                              <label class="is-size-6" style="font-size: 15px !important" for="{{data.question_id}}-{{ option.answer_id }}">{{option.answer}}</label>
                            </div>
                          </div>
                        </div>
                      </div> -->
                      <span
                        *ngIf="
                          data.is_correct_answer === true;
                          else elseTemplate
                        "
                      >
                        <span class="has-text-success">{{ data.answer }}</span>
                      </span>
                      <ng-template #elseTemplate>
                        <span class="has-text-danger">{{ data.answer }}</span>
                      </ng-template>
                    </div>
                    <ng-template #elseTemplate>
                      <h4
                        class="subtitle"
                        style="
                          font-size: 14px;
                          margin-bottom: 5px;
                          color: #008000;
                        "
                      >
                        Answer:
                      </h4>
                      <span>
                        {{ data.user_answer }}
                      </span>
                      <!-- <input type="text" class="input" placeholder="Enter the mark"/> -->
                    </ng-template>
                  </div>
                </div>
                <footer class="card-footer">
                  <div class="column is-12 has-text-right">
                    <button
                      type="button"
                      class="button mar-0-5 is-small"
                      (click)="removeIndStudentResult()"
                    >
                      Back
                    </button>
                    <!-- <button type="button" class="button is-link is-small disabledBtn" (click)="createNewFileData(uploadFileForm.value)" [disabled]="!uploadFileForm.valid || upLoadedFileList.length === 0" *ngIf="!showBtnSpinner">  Submit</button>
                    <a class="button is-link is-loading is-small" style="min-width: 100px;"  *ngIf="showBtnSpinner"></a> -->
                  </div>
                </footer>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>



  <!---Survey Records-->
  <div class="modal" [ngClass]="{'is-active': showHideSurveyModal[mesgIds]}" >
    <div class="modal-background"></div>
    <div class="modal-card" style="padding:20px;">
      <div class="card" *ngIf="isUserRole!=1 && viewControl.showAssessmentMarks">
          <div class="card-header">
            <p class="card-header-title">Survey Quiz</p>
            <button type="button" class="button is-outlined is-small" style="margin-top: 7px;" (click)="hideSurveyQuizModal(mesgIds)">Cancel</button>
          </div>
          <div class="card-content scroll-bar pos-relative" infinite-scroll>
            <div class="content">
              <div class="question" *ngIf="mode=='surveyQuiz'">
                <div *ngFor="let data of filteredQuestions; let i=index">
                  <div class="badge badge-info"> Question {{pager.index + 1 }} of {{pager.count}}</div>
                  <h3 class="is-medium label">{{pager.index +  1}}.
                    <span class="is-medium" [innerHTML]="data.question"></span>
                  </h3>
                  <div class="options surveyquiz" >
                    <div class="" *ngFor="let option of data.answer; let i=index">
                      <div class="option has-text-grey-light">
                        <div class="field">
                          <input class="is-checkradio" id="{{ option.answer_id }}-{{data.question_id}}" type="radio"  name="{{data.question_id}}-answers" [(ngModel)]="option.selected" value="{{option.answer_id}}" (change)="onSelectedSurRadio(data, option)" #surveyCheck>
                          <label [attr.for]="option.answer_id + '-'+ data.question_id ">{{option.answer}}</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <footer class="card-footer">
            <nav class="pagination is-small" role="navigation" aria-label="pagination">
              <button type="button" class="button is-outlined pagination-previous" [ngClass]="{'hidePreviousBtn': pager.index===0}" [disabled]="pager.index==0" [hidden]="pager.index > 1" (click)="getPreviewNext(pager.index - 1)">Previous</button>
              <div *ngIf="pager.index + 1>= pager.count; else elseTemplate">
                <button type="button" class="button is-link is-small pagination-next answerSubmit" [disabled]="!surveySubmit" *ngIf="!showBtnSpinner" (click)="submitAssessmentQuiz(filteredQuestions, mesgIds, 'survey')">Submit Answer</button>
                <a class="button is-link is-loading is-small answerSubmit" style="min-width: 100px;"  *ngIf="showBtnSpinner"></a>
              </div>
              <ng-template #elseTemplate>
                <button type="button" class="button is-outlined pagination-next" (click)="getPreviewNext(pager.index + 1)">Next</button>
              </ng-template>
            </nav>
          </footer>
      </div>

      <div class="card" *ngIf="!viewControl.showAssessmentMarks">
        <div class="card-header">
          <p class="card-header-title">Survey Quiz</p>
          <button class="delete" aria-label="close" (click)="hideSurverModal(mesgIds)"></button>
        </div>
        <div class="card-content">
          <div class="content">
            <span class="is-small" >Already survey is completed</span>
          </div>
        </div>
      </div>

      <div class="card" *ngIf="isUserRole===1">
        <div class="card-header">
          <p class="card-header-title">Survey Result</p>
          <button class="delete" aria-label="close" (click)="hideSurverModal(mesgIds)"></button>
        </div>
        <div class="card-content">
          <div class="content">
            <div class="question" *ngIf="mode=='surveyQuiz'">
              <div *ngFor="let data of filterReportSurvey; let i=index">
                <div class="badge badge-info"> Question {{pager.index + 1 }} of {{pager.count}}</div>
                <h3 class="is-medium label">{{pager.index +  1}}.
                  <span class="is-medium" [innerHTML]="data.question"></span>
                </h3>
                <div class="options surveyquiz" >
                  <div class="" *ngFor="let opt of data.answer; let i=index">
                    <div class="option has-text-grey-light">
                      <div class="field">
                        <span class="is-small" [innerHTML]="opt.answer"></span>
                        <span class="has-text-right" style="float: right;">{{opt.count}} Votes</span>
                        <progress class="progress is-info" [ngClass]="{'is-success': totalUserCount > opt.count}" value="{{opt.count}}" max="{{totalUserCount}}">{{opt.count}}</progress>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <footer class="card-footer">
          <nav class="pagination is-small" role="navigation" aria-label="pagination">
            <button type="button" class="button is-outlined pagination-previous" [disabled]="pager.index==0" (click)="getPreviewNext(pager.index - 1)">Previous</button>
          <button type="button" class="button is-outlined pagination-next" [disabled]="pager.index + 1>= pager.count" (click)="getPreviewNext(pager.index + 1)">Next</button>
          </nav>
        </footer>
      </div>
    </div>
  </div>

  <!--Poll Records -->
  <div class="modal" [ngClass]="{'is-active': showHidePollModal[mesgIds]}">
    <div class="modal-background"></div>
    <div class="modal-card" style="padding:20px;">
      <div class="card" *ngIf="isUserRole!=1 && viewControl.showAssessmentMarks">
          <div class="card-header">
            <p class="card-header-title">Poll Quiz</p>
            <button class="delete" aria-label="close" (click)="hidePollActiveModal(mesgIds)"></button>
          </div>
          <div class="card-content">
            <div class="content">
              <div class="question" *ngIf="getmode=='pollsQuiz'">
                <div *ngFor="let data of pollfilterQuestions; let i=index">
                  <div class="badge badge-info"> Question {{pager.index + 1 }} of {{pager.count}}</div>
                  <h3 class="is-medium label">{{pager.index +  1}}.
                    <span class="is-medium" [innerHTML]="data.question"></span>
                  </h3>
                  <div class="options surveyquiz" >
                    <div class="" *ngFor="let option of data.answer; let i=index">
                      <div class="option has-text-grey-light">
                        <div class="field">
                          <input class="is-checkradio" id="{{ option.answer_id }}-{{data.question_id}}" type="radio"  name="{{data.question_id}}-answers" [(ngModel)]="option.selected" value="{{option.answer_id}}" (change)="onSelectedSurRadio(data, option)" #surveyCheck>
                          <label [attr.for]="option.answer_id + '-'+ data.question_id ">{{option.answer}}</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <footer class="card-footer">
            <nav class="pagination is-small" role="navigation" aria-label="pagination">
              <button type="button" class="button is-outlined pagination-previous" [ngClass]="{'hidePreviousBtn': pager.index===0}"  [disabled]="pager.index==0"  (click)="getPollNextPrev(pager.index - 1)">Previous</button>
              <div *ngIf="pager.index + 1>= pager.count; else elseTemplate">
                <button type="button" class="button is-link is-small pagination-next answerSubmit" [disabled]="!pollBtnSubmit" *ngIf="!showBtnSpinner" (click)="submitAssessmentQuiz(pollfilterQuestions, mesgIds, 'polls')">Submit Answer</button>
                <a class="button is-link is-loading is-small answerSubmit" style="min-width: 100px;"  *ngIf="showBtnSpinner"></a>
              </div>
              <ng-template #elseTemplate>
                <button type="button" class="button is-outlined pagination-next" (click)="getPollNextPrev(pager.index + 1)">Next</button>
              </ng-template>
            </nav>
          </footer>
      </div>

      <div class="card" *ngIf="!viewControl.showAssessmentMarks">
        <div class="card-header">
          <p class="card-header-title">Poll Quiz</p>
          <button class="delete" aria-label="close" (click)="hidePollModal(mesgIds)"></button>
        </div>
        <div class="card-content">
          <div class="content">
            <span class="is-small" >Already poll is completed</span>
          </div>
        </div>
      </div>

      <div class="card" *ngIf="isUserRole===1">
        <div class="card-header">
          <p class="card-header-title">Poll Result</p>
          <button class="delete" aria-label="close" (click)="hidePollModal(mesgIds)"></button>
        </div>
        <div class="card-content">
          <div class="content">
            <div class="question" *ngIf="mode=='surveyQuiz'">
              <div *ngFor="let data of pollsfilterReports; let i=index">
                <div class="badge badge-info"> Question {{pager.index + 1 }} of {{pager.count}}</div>
                <h3 class="is-medium label">{{pager.index +  1}}.
                  <span class="is-medium" [innerHTML]="data.question"></span>
                </h3>
                <div class="options surveyquiz" >
                  <div class="" *ngFor="let opt of data.answer; let i=index">
                    <div class="option has-text-grey-light">
                      <div class="field">
                        <span class="is-small" [innerHTML]="opt.answer"></span>
                        <span class="has-text-right" style="float: right;">{{opt.count}} Votes</span>
                        <progress class="progress is-info" [ngClass]="{'is-success': totalUserCount > opt.count}" value="{{opt.count}}" max="{{totalUserCount}}">{{opt.count}}</progress>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <footer class="card-footer">
          <nav class="pagination is-small" role="navigation" aria-label="pagination">
            <button type="button" class="button is-outlined pagination-previous"  [disabled]="pager.index===0" (click)="getPollNextPrev(pager.index - 1)">Previous</button>
          <button type="button" class="button is-outlined pagination-next" [disabled]="pager.index + 1>= pager.count" (click)="getPollNextPrev(pager.index + 1)">Next</button>
          </nav>
        </footer>
      </div>
    </div>
  </div>
</div>
